import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./user.module.css";
import { useSelector, useDispatch } from "react-redux";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { checkInput } from "../../utils/util_functions";
import { EDIT_EMAIL_RESEND, postResendActivationThunk } from "../../services/actions/resend_activation_actions";
import { getDataFromRoutes, setMetaTags, generateCode } from "../../utils/util_functions";
import { getResendForm, getLoading } from "../../services/selectors";
import Loader from "../../components/loader/loader";
import { ROUTES_CONST } from "../../utils/constants";
import Captcha from "../../components/captcha/captcha";


const ResendActivation = () => {

  const [statusEmail, setStatusEmail] = useState({});
  const [formValid, setFormValid] = useState(false);
  const [code, setCode] = useState();
  const [validCaptcha, setValidCaptcha] = useState(true);
  const [seed, setSeed] = useState(0);

  const captchaRef = useRef(null);

  const isLoading = useSelector(getLoading);
  const { email } = useSelector(getResendForm);

  const navigate = useNavigate();

  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);
  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFormValid(checkInput(email, 8, 64, 'email').valid && validCaptcha);
    // eslint-disable-next-line
  }, [email, validCaptcha]);


  const handleSubmit = (e) => {
    e.preventDefault();
    setSeed(Math.random());
    dispatch(postResendActivationThunk(email.toLowerCase(), navigate));
  }


  const changeEmail = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'email');
    setStatusEmail({ ...statusEmail, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_EMAIL_RESEND, email: e.target.value });
  }

  return (
    <main className='main'>
      {isLoading ? <Loader /> : null}
      <h1 className="title title__left">
        {title}
      </h1>
      <div className={styles.box}>
        <form onSubmit={handleSubmit} className="form" noValidate >
          <label htmlFor="email" className="label_text">
            Email <span style={{ color: 'red' }}>*</span>
            <input
              type="email"
              id="email" name="email"
              required={true}
              value={email}
              onChange={changeEmail}
              className="input"
            />
            <p className="error">{statusEmail?.text}</p>
          </label>
          <label htmlFor="captcha" className="label_text">
            Защита от ботов <span style={{ color: 'red' }}>*</span>
            <Captcha
              generateCode={() => generateCode(setCode)}
              setValidCaptcha={setValidCaptcha}
              code={code}
              ref={captchaRef}
              key={seed}
            />
            {!validCaptcha && <p className="error error_captcha">Неправильный код.</p>}
          </label>
          <div className={styles.button_container}>
            <button type="submit"
              className={`button ${!formValid ? `button_disabled` : ''}`}
              disabled={!formValid}
            >
              Запросить активацию
            </button>
          </div>
        </form>
        <div className={styles.aside_block}>
          <p className="text__gray">
            Введите e-mail, который указывали при регистрации.
            Через несколько минут на него придет письмо со ссылкой
            для активации учётной записи.
          </p>
        </div>
      </div>
    </main>
  );
}

export default ResendActivation;
